import React from 'react';
import { TableRow, TableCell, Box } from '@mui/material';
import GoalStaticTableCell from './GoalStaticTableCell';

const GoalStaticsHeadquarterRow = ({ data, headers }) => {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return (
      <TableRow>
        <TableCell colSpan={(headers?.length || 0) + 1} align="center" sx={{ py: 3 }}>
          데이터가 없습니다.
        </TableCell>
      </TableRow>
    );
  }

  const cellStyle = {
    border: '1px solid #e0e0e0',
    fontSize: '0.875rem',
    padding: '8px',
  };

  return (
    data.map((hq, hIndex) => {
      const isTotalRow = hq.id === 'total' || hIndex === data.length - 1;

      return (
        <TableRow 
          key={hIndex} 
          sx={{ backgroundColor: isTotalRow ? '#edf2f7' : 'inherit' }}
        >
          <TableCell 
            align="center" 
            sx={{ 
              ...cellStyle,
              width: 200, 
              fontWeight: 'bold',
              color: '#333',
              backgroundColor: isTotalRow ? '#edf2f7' : '#f5f5f5'
            }}
          >
            {hq.name}
          </TableCell>
          <GoalStaticTableCell data={hq} headerRows={headers} />
        </TableRow>
      );
    })
  );
};

export default GoalStaticsHeadquarterRow;
